import Select from 'react-select';
import {getReactSelectDefaultProps} from 'config/react-select';
import React, {Fragment, useCallback} from 'react';
import _ from 'lodash';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {showEwsFwdQuestion} from 'module/SessionInfo/util/showEwsFwdQuestion';

export const EwsRepSelect = ({
	loading,
	options,
	ewsRep,
	disabledFwd,
	index,
	setEwsRepList,
}) => {
	const editRep = useCallback((displayName, repAddress, useFwdRule) =>
		setEwsRepList(r => r.map((x, i) =>
			i !== index ? x :
				{
					displayName,
					repAddress,
					useFwdRule,
				},
		)), [index, setEwsRepList]);
	const deleteRep = useCallback(() => setEwsRepList(r => r.filter((x, i) => i !== index)), [index, setEwsRepList]);
	const onChangeUseFwdRule = useCallback((evt, val) => {
		if (ewsRep && ewsRep.repAddress && val) {
			showEwsFwdQuestion()
				.then(() => editRep(ewsRep.displayName, ewsRep.repAddress, true))
				.catch(() => editRep(ewsRep.displayName, ewsRep.repAddress, false));
		} else {
			editRep(ewsRep.displayName, ewsRep.repAddress, false)
		}
	}, [editRep, ewsRep]);
	const selectChangeHandler = useCallback((value) => {
		if (value) {
			const {displayName, repAddress, useFwdRule} = value;
			editRep(displayName, repAddress, useFwdRule);
		} else {
			deleteRep();
		}
	}, [deleteRep, editRep]);
	const value = ewsRep && ewsRep.repAddress ? ewsRep : null;
	const useFwdRule = ewsRep && ewsRep.useFwdRule === true;
	return (
		<Fragment>
			<Select
				{...getReactSelectDefaultProps({
					isLoading: loading,
					isDisabled: loading,
					isClearable: true,
					options: options,
					value: value,
					getOptionValue: x => x,
					getOptionLabel: x => `${x.repAddress} - ${x.displayName}`,
					onChange: selectChangeHandler,
				})}
			/>
			{!disabledFwd &&
			<FormControlLabel
				label={'Weiterleitungsregel bei Abwesenheit einrichten'}
				control={
					<Checkbox
						disabled={loading || _.isEmpty(ewsRep.repAddress) && disabledFwd}
						checked={useFwdRule}
						onChange={onChangeUseFwdRule}
					/>
				}
			/>
			}
		</Fragment>
	)
};